<template>

    <section class="trusted-companies">

        <div class="trusted-companies__header">

            <span>
                {{ 'home_trusted_companies' | staticTitle }}
            </span>

        </div>

        <div
            v-if="companies.length"
            class="trusted-companies__track"
        >

            <div
                v-for="company in companies"
                :key="company.id"
                class="trusted-company"
                :class="company.className"
            >

                <img
                    v-if="company.image"
                    :src="company.image"
                    :alt="company.title"
                >

            </div>

        </div>

    </section>

</template>

<script>
import { imageIdToURL } from '@/utils';

export default {
    name: 'TrustedCompanies',

    computed: {
        companies() {
            const items =
                this.$options.filters.portfolioFetchBy(
                    'trusted_company'
                );

            if (
                !Array.isArray(items) ||
                !items.length
            ) {
                return [];
            }

            const order = [
                'financiera tamazula',
                'blackfon',
                'supereasy',
                'refaapp',
                'durabilidad',
                'durabilidad y control'
            ];

            return items
                .map(item => {
                    const title =
                        String(
                            item.title || ''
                        )
                            .trim();

                    const normalizedTitle =
                        title
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(
                                /[\u0300-\u036f]/g,
                                ''
                            );

                    return {
                        id:
                            item.id,

                        title,

                        normalizedTitle,

                        image:
                            item.imagenes_id
                                ? imageIdToURL(
                                    item.imagenes_id
                                )
                                : '',

                        className:
                            this.getCompanyClass(
                                normalizedTitle
                            )
                    };
                })
                .sort((a, b) => {
                    const indexA =
                        this.getCompanyOrder(
                            a.normalizedTitle,
                            order
                        );

                    const indexB =
                        this.getCompanyOrder(
                            b.normalizedTitle,
                            order
                        );

                    return indexA - indexB;
                });
        }
    },

    methods: {
        getCompanyOrder(title, order) {
            const index =
                order.findIndex(
                    item =>
                        title.includes(item)
                );

            return index === -1
                ? 999
                : index;
        },

        getCompanyClass(title) {
            if (
                title.includes(
                    'financiera'
                )
            ) {
                return 'trusted-company--financiera';
            }

            if (
                title.includes(
                    'blackfon'
                )
            ) {
                return 'trusted-company--blackfon';
            }

            if (
                title.includes(
                    'supereasy'
                )
            ) {
                return 'trusted-company--supereasy';
            }

            if (
                title.includes(
                    'refaapp'
                )
            ) {
                return 'trusted-company--refaapp';
            }

            if (
                title.includes(
                    'durabilidad'
                )
            ) {
                return 'trusted-company--durabilidad';
            }

            return '';
        }
    }
};
</script>

<style lang="scss" scoped>
.trusted-companies {
    position: relative;

    padding:
        3.5em 1.25em
        4em;

    background:
        var(--color-1);

    border-top:
        .0625em solid
        var(--border-1);

    border-bottom:
        .0625em solid
        var(--border-1);

    overflow: hidden;
}

.trusted-companies__header {
    margin-bottom:
        2.5em;

    text-align:
        center;

    span {
        display:
            inline-flex;

        align-items:
            center;

        gap:
            1em;

        color:
            var(--text-2);

        font-family:
            var(--font-tech);

        font-size:
            .625em;

        font-weight:
            600;

        letter-spacing:
            .15em;

        text-transform:
            uppercase;

        &::before,
        &::after {
            content: "";

            width:
                2.4em;

            height:
                .0625em;

            background:
                var(--color-3);
        }
    }
}

.trusted-companies__track {
    display:
        grid;

    grid-template-columns:
        repeat(2, minmax(0, 1fr));

    align-items:
        center;

    gap:
        1.25em;

    width:
        100%;

    max-width:
        var(--container);

    margin:
        0 auto;
}

.trusted-company {
    display:
        flex;

    align-items:
        center;

    justify-content:
        center;

    min-width:
        0;

    min-height:
        6.5em;

    padding:
        1.2em 1em;

    background:
        rgba(
            255,
            255,
            255,
            .012
        );

    border:
        .0625em solid
        rgba(
            255,
            255,
            255,
            .035
        );

    transition:
        border-color .3s ease,
        background .3s ease,
        transform .3s ease;

    img {
        display:
            block;

        width:
            auto;

        height:
            auto;

        max-width:
            82%;

        max-height:
            4.5em;

        object-fit:
            contain;

        filter:
            grayscale(1)
            brightness(1.55);

        opacity:
            .68;

        transition:
            filter .3s ease,
            opacity .3s ease,
            transform .3s ease;
    }

    &:hover {
        border-color:
            rgba(
                233,
                81,
                29,
                .22
            );

        background:
            rgba(
                255,
                255,
                255,
                .022
            );

        transform:
            translateY(-.15em);

        img {
            filter:
                grayscale(0)
                brightness(1);

            opacity:
                1;
        }
    }
}

.trusted-company--financiera {
    img {
        max-width:
            84%;

        max-height:
            4.7em;

        transform:
            scale(1.05);
    }

    &:hover img {
        transform:
            scale(1.1);
    }
}

.trusted-company--blackfon {
    img {
        max-width:
            88%;

        max-height:
            5em;

        transform:
            scale(1.14);
    }

    &:hover img {
        transform:
            scale(1.2);
    }
}

.trusted-company--supereasy {
    img {
        max-width:
            76%;

        max-height:
            4.5em;

        transform:
            scale(1.03);
    }

    &:hover img {
        transform:
            scale(1.08);
    }
}

.trusted-company--refaapp {
    img {
        max-width:
            88%;

        max-height:
            5em;

        transform:
            scale(1.16);
    }

    &:hover img {
        transform:
            scale(1.22);
    }
}

.trusted-company--durabilidad {
    img {
        max-width:
            82%;

        max-height:
            4.6em;

        transform:
            scale(1.08);
    }

    &:hover img {
        transform:
            scale(1.13);
    }
}

@media (min-width: 600px) {
    .trusted-companies__track {
        grid-template-columns:
            repeat(
                3,
                minmax(0, 1fr)
            );
    }
}

@media (min-width: 900px) {
    .trusted-companies {
        padding:
            4em 2.5em
            4.5em;
    }

    .trusted-companies__track {
        grid-template-columns:
            repeat(
                5,
                minmax(0, 1fr)
            );

        gap:
            .75em;
    }

    .trusted-company {
        min-height:
            7.4em;

        padding:
            1.4em .9em;
    }
}

@media (min-width: 1200px) {
    .trusted-companies {
        padding:
            4.3em 3.75em
            4.8em;
    }

    .trusted-company {
        min-height:
            8em;
    }
}
</style>